(function ($) {

    $(() => {
        if ($('.js-product-slider').length) {

            var productSliderThumbs = new Swiper(".js-product-slider-thumbs", {
                loop: false,
                spaceBetween: 20,
                slidesPerView: "auto",
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                centeredSlides: true,

            });

            var productSlider = new Swiper(".js-product-slider", {
                loop: false,
                spaceBetween: 11,
                effect: "fade",
                thumbs: {
                    swiper: productSliderThumbs,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        }


        if ($('.js-popular-products').length) {
            var popularProducts = new Swiper(".js-popular-products", {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: ".js-popular-products-next",
                    prevEl: ".js-popular-products-prev",
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    },
                    520: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },


            });

        }




    });
})(jQuery);


